import React from 'react';

const JS_Editor = () => {
  return (
    <div >
      <h1>JS_Editor</h1>
      <p>Placeholder component for: "JS Editor"</p>
    </div>
  );
};

export default JS_Editor;
